// src/index.ts
import { mergeProps } from "@react-aria/utils";
import { useAriaLabel } from "@nextui-org/use-aria-label";
import { useAriaSlotId } from "@nextui-org/use-aria-slot-id";
function useAriaField(props = {}) {
  let { description, errorMessage, validationState } = props;
  let { labelProps, fieldProps } = useAriaLabel(props);
  let descriptionId = useAriaSlotId([Boolean(description), Boolean(errorMessage), validationState]);
  let errorMessageId = useAriaSlotId([
    Boolean(description),
    Boolean(errorMessage),
    validationState
  ]);
  fieldProps = mergeProps(fieldProps, {
    "aria-describedby": [
      descriptionId,
      errorMessageId,
      props["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  });
  return {
    labelProps,
    fieldProps,
    descriptionProps: {
      id: descriptionId
    },
    errorMessageProps: {
      id: errorMessageId
    }
  };
}
export {
  useAriaField
};
